import React from 'react';
import { injectIntl } from 'react-intl';
import { parseClasses, autotranslateText, isNotEmpty } from '../../lib/ep';
import ButtonCollection from '../builder/ButtonCollection';

const ModuleHeader = (props) => {
	if(props.children == undefined) return null;
	const custom_title = props?.custom_title ?? false;
	const has_html = props?.has_html ?? false;

	let _classes = ['module_header'];
	if(props._class != undefined) _classes.push(parseClasses('', props._class, 'generic_item'));
	if(props.actions == undefined) _classes.push('without_actions');

	let title_class = ['h'];
	if(props.icon != undefined) title_class.push(props.icon);

	const autotranslate = props?.autotranslate ?? true;

	const subtitle = (isNotEmpty(props, 'subtitle')) ? props.subtitle : false;

	return (
		<>
			<header class={_classes.join(" ")}>
				{(!custom_title && !has_html) && (
					<h2 class={title_class.join(" ")}>
						{autotranslateText(props.children, props.autotranslate, props.intl)}

						{(props.tooltip != undefined) && (
							props.tooltip
						)}
					</h2>
				)}

				{(custom_title && !has_html) && (
					autotranslateText(props.children, props.autotranslate, props.intl)
				)}

				{(has_html) && (
					<h2 class={title_class.join(" ")} dangerouslySetInnerHTML={{ __html:props.children }} />
				)}

				{(props.actions != undefined) && (
					<ButtonCollection
						{...props.action_container_props}
					>
						{props.actions}
					</ButtonCollection>
				)}
			</header>

			{(subtitle && autotranslate) && (
				<p class="header_subtitle">{autotranslateText(props.subtitle, true, props.intl)}</p>
			)}

			{(subtitle && !autotranslate && typeof props.subtitle === 'object') && (
				<p class="header_subtitle">{props.subtitle}</p>
			)}

			{(subtitle && !autotranslate && typeof props.subtitle !== 'object') && (
				<p class="header_subtitle" dangerouslySetInnerHTML={{ __html:props.subtitle }} />
			)}

			{(props.total != undefined) && (
				<p class="header_total" dangerouslySetInnerHTML={{ __html:props.total }} />
			)}
		</>
	)
};

export default injectIntl(ModuleHeader);